import { Component, Input } from '@angular/core';
import { HEADING_TYPES, HEADING_SIZES } from './heading.enum';

// tslint:disable:template-cyclomatic-complexity
@Component({
	selector: 'ea-heading',
	templateUrl: './heading.component.html',
	styleUrls: ['./heading.component.scss']
})
export class HeadingComponent {
	@Input() name?: string;
	HEADING_TYPES = HEADING_TYPES;
	HEADING_SIZES = HEADING_SIZES;

	@Input() type = HEADING_TYPES.h2;
	@Input() size = HEADING_SIZES.md;
	@Input() color: string;
	@Input() isBgWhite: boolean;
	@Input() noMargin: boolean = false;
	@Input() capitalize: boolean = false;
}
